<template>
	<div
		v-if="exibir"
		id="janela-notificacao"
		class="janela-notificacao"
		:class="{ card: !notificacaoComBotao, button: notificacaoComBotao }"
	>
		<div v-if="!notificacaoComBotao" id="cardTitle" class="card_title">
			<slot name="title">
				<span> {{ tituloNotificacao }} </span>
			</slot>

			<v-spacer></v-spacer>

			<v-btn id="botaoMinimizar" icon @click="minimizarJanela">
				<v-icon v-if="scroll" size="18" color="white">mdi-chevron-down</v-icon>
				<v-icon v-else size="18" color="white">mdi-chevron-up</v-icon>
			</v-btn>
			<v-btn v-if="exibirIconeClose" id="botaoClose" icon @click="$emit('close')">
				<v-icon size="18" color="white">mdi-close</v-icon>
			</v-btn>
		</div>

		<slot v-else name="botaoNotificacao">
			<v-badge v-if="exibirIconeClose" avatar borderer overlap>
				<template #badge>
					<v-avatar>
						<v-btn color="error" fab x-small dark @click="$emit('close')">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-avatar>
				</template>

				<v-btn id="buttonNotification" color="primary" fab large dark @click="minimizarJanela">
					<v-icon>mdi-draw-pen</v-icon>
				</v-btn>
			</v-badge>
			<v-btn v-else id="buttonNotification" color="primary" fab large dark @click="minimizarJanela">
				<v-icon>mdi-draw-pen</v-icon>
			</v-btn>
		</slot>

		<slot name="contentBody">
			<transition
				:css="false"
				appear
				@before-enter="beforeEnterAnimation"
				@enter="enterAnimation"
				@before-leave="beforeLeaveAnimation"
				@leave="leaveAnimation"
			>
				<v-card
					v-if="scroll"
					id="content"
					elevation="15"
					class="scroll"
					:class="{ 'scroll-button': notificacaoComBotao }"
					:style="{
						'max-height': `${alturaMaxima}px`,
						width: notificacaoComBotao ? `${larguraMaxima}px` : '100%',
					}"
				>
					<slot name="content"></slot>
				</v-card>
			</transition>
		</slot>
	</div>
</template>

<script>
export default {
	name: 'janela-de-notificacao',
	props: {
		alturaMaxima: {
			type: Number,
			default: 250,
		},
		exibir: {
			type: Boolean,
			required: true,
		},
		exibirNotificacaoDefault: {
			type: Boolean,
		},
		exibirIconeClose: {
			type: Boolean,
		},
		larguraMaxima: {
			type: Number,
			default: 250,
		},
		notificacaoComBotao: {
			type: Boolean,
		},
		tituloNotificacao: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			scroll: true,
			alturaConteudoInterno: 0,
		}
	},
	methods: {
		animation(el, done, negativo) {
			let rodada = 1
			const animation = setInterval(() => {
				let novaAltura = this.alturaConteudoInterno + (negativo ? -rodada * 5 : rodada * 5)

				rodada++

				this.setAltura(el, novaAltura)

				if (rodada > 10) {
					clearInterval(animation)
					done()
				}
			}, 20)
		},
		beforeEnterAnimation(el) {
			this.setAltura(el, 0)
		},
		beforeLeaveAnimation(el) {
			this.setAltura(el, this.alturaMaxima)
		},
		enterAnimation(el, done) {
			this.animation(el, done, false)
		},
		leaveAnimation(el, done) {
			this.animation(el, done, true)
		},
		minimizarJanela() {
			if (!this.exibirNotificacaoDefault) {
				this.$emit('minimizar-janela')
			}

			this.scroll = !this.scroll
		},
		setAltura(el, novaAltura) {
			this.alturaConteudoInterno = novaAltura
			el.style.height = `${novaAltura}px`
		},
	},
}
</script>

<style lang="stylus" scoped>

.janela-notificacao
	position fixed
	z-index 1

.button
	display flex
	flex-direction row-reverse
	align-items end
	right 25px
	bottom 37px
	border none

.scroll
	overflow-y scroll
	width 300px

.scroll-button
	min-width 200px
	margin-bottom 25px
	margin-right 13px

.card
	right 0
	bottom 0
	border 1px solid #ebebeb
	min-width 350px
	background-color #fff
	z-index 4

	.card_title
		display flex
		background #0067A5
		padding 15px 20px
		color #fdfdfd
		font-weight 300
		font-size 15px
		align-content center
		justify-content center
		align-items center
		max-height 50px

@media screen and (max-width: 768px)
	.button
		display flex
		flex-direction row
		align-items end
		right none
		left 15px
		bottom 37px
		border none

	.scroll-button
		min-width 200px
		margin-bottom 25px
		margin-left 13px

	.card
		width 100%
		z-index 4
</style>
